<ng-container *cftI18n="let t">
  <a
    [routerLink]="path"
    [queryParams]="queryParams"
    class="btn text-base"
    [class.btn-ghost]="!light"
    [class.btn-ghost-light]="light"
  >
    <fa-icon [icon]="backIcon" class="md:btn-left-icon"></fa-icon>
    <span class="hidden md:block">{{ t('breadcrumbs.back') }}</span>
  </a>
</ng-container>
